<template>
  <div class="multiselect filter-form-box" id="customSelectBox" ref="custom-select" @click="openDropdown">
    <div id="selectedItemBox" class="selectBox">
      <span class="pt-10">
        {{ selectedItemText }}
      </span>
      <span v-show="errors.has('language')" class="error-style">{{ errorText }}</span>
      <div class="overSelect"></div>
    </div>
    <div v-if="isDisplayOptions" id="selectOptionsDiv" class="select-scroll activity-builder-select-options">
      <input type="text" class="language-search-bar" placeholder="Enter a language to filter" v-if="search" v-model="searchKey" />
      <div :class="['check_label_input d-flex custom-control custom-checkbox', option[itemKey] === componentValue ? 'sel-item' : '']" v-for="option in filteredOptions" :key="option[itemKey]" @click="onSelect($event, option)">
        <input class="custom-control-input" v-if="checkbox" :id="option[itemKey]" type="checkbox" />
        <label :class="[checkbox ? 'custom-control-label' : '']" :for="option[itemKey]">{{ option[itemText] }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "custom-form-select",

  data() {
    return {
      isDisplayOptions: false,
      optionsData: this.options,
      componentValue: this.value,
      searchKey: ""
    };
  },

  props: {
    options: {
      type: Array,
      default: () => []
    },
    title: {},
    errorText: {},
    value: {
      default: ""
    },
    required: { type: Boolean, default: true },
    returnObject: { type: Boolean, default: false },
    search: { type: Boolean, default: false },
    checkbox: { type: Boolean, default: false },
    itemKey: { type: String, default: "id" },
    itemText: { type: String, default: "text" },
    singleSelection: { default: true },
    width: {
      default: "auto"
    }
  },
  watch: {
    options(val) {
      this.optionsData = val;
    },
    value(val) {
      this.componentValue = val;
    }
  },
  computed: {
    selectedItem() {
      return this.optionsData.find(item => item[this.itemKey] === this.componentValue);
    },
    selectedItemText() {
      return this.selectedItem ? this.selectedItem[this.itemText] : this.title;
    },
    filteredOptions() {
      return this.optionsData.filter(() => {
        return true;
      });
    }
  },
  updated() {
    this.clickBindingForDefault();
  },
  methods: {
    onSelect(evt, option) {
      evt.stopPropagation();
      const val = this.returnObject ? option : option[this.itemKey];
      if (val !== this.componentValue) {
        this.$emit("change", val);
        this.$emit("input", val);
        this.closeDropdown();
      }
    },
    onSelectOptionsShowing() {
      this.clickBindingForDefault();
      window.addEventListener("keyup", e => {
        if (e.key === "Escape") {
          this.closeDropdown();
        }
      });
    },
    clickBindingForDefault() {
      window.addEventListener("click", e => {
        if (document.getElementById("customSelectBox") && !document.getElementById("customSelectBox").contains(e.target)) {
          // Clicked outside the box
          this.closeDropdown();
        } else {
          if (this.isDisplayOptions === false) {
            e.stopPropagation();
            this.openDropdown();
          }
        }
      });
    },
    openDropdown() {
      this.isDisplayOptions = true;
      this.onSelectOptionsShowing();
    },
    closeDropdown() {
      this.isDisplayOptions = false;
    }
  }
};
</script>
<style scoped>
#selectOptionsDiv {
  background: #fff;
  position: absolute;
  top: 40px;
  width: 186px;
  height: max-content;
  border-radius: 3px;
  padding: 0px;
  overflow: auto;
  z-index: 3;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  margin-left: -12px;
}

#selectOptionsDiv .check_label_input {
  padding: 8px 9px;
}

#selectOptionsDiv .check_label_input.sel-item {
  background-color: #f5f8fa;
}

#selectOptionsDiv .check_label_input:hover {
  background-color: #f5f8fa;
}

div#customSelectBox {
  background-image: url("/static/img/arrow-down.png");
  background-repeat: no-repeat;
  background-position: center right;
  padding-right: 24px;
  min-width: max-content;
}
</style>
